import { Reveal } from "@/components/Reveal";
import { Globe } from "@/components/Globe";

const IMG =
  "https://images.unsplash.com/photo-1540039155733-5bb30b53aa14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxkYXJrJTIwaG91c2UlMjBtdXNpYyUyMGNsdWIlMjBjcm93ZHxlbnwwfHx8fDE3ODgwMzczMDV8MA&ixlib=rb-4.1.0&q=85";

export const About = () => (
  <section className="border-b-2 border-[#f4f4f2]" data-testid="about-section">
    <div className="mx-auto grid max-w-[1100px] items-center gap-10 px-6 py-16 md:grid-cols-[0.7fr_1.4fr] md:py-24">
      <Reveal className="flex justify-center">
        <Globe spin slower className="w-full max-w-[190px] text-[#f4f4f2]" />
      </Reveal>
      <div>
        <Reveal>
          <h2 className="font-display text-[clamp(1.7rem,4.4vw,2.4rem)] uppercase tracking-tight">
            The Home of House.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-5 text-base leading-relaxed md:text-lg">
            Housegemacht ist eine junge Eventmarke für House-Musik abseits vom Mainstream. Der Name
            ist Programm: so ehrlich und selbstgemacht wie eine gebrannte Platte — organisiert von
            Leuten, die selbst auf der Tanzfläche stehen wollen.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-4 text-base leading-relaxed md:text-lg">
            Das erste Event ist gerade in Planung. Diese Seite ist der Anfang — mehr folgt in Kürze.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="group mt-8 overflow-hidden border-2 border-[#f4f4f2]">
            <img
              src={IMG}
              alt="Crowd vor beleuchteter Bühne"
              data-testid="about-image"
              className="h-52 w-full object-cover grayscale transition-all duration-700 group-hover:scale-[1.03] group-hover:grayscale-0 md:h-64"
            />
          </div>
          <p className="mt-4 max-w-[520px] text-base font-semibold leading-relaxed md:text-lg">
            Wenn der Floor vibriert, die Zeit verfliegt und aus Fremden Freunde werden — genau
            dafür kreieren wir diese Nächte.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
